module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/onesence-1-863c430a377df7869c40e7a9a493c4dc.webp";